import React, { Component } from "react";
import history from "../../../Utils/History";
import { connect } from "react-redux";
import {
  yearSelection,
  removeplan,
  agentCategoryDashboard,
  setStateParams,
  setLoginStateParams,
  getPlansEmail,
  guestLogin,
  setTokenTORedux,
  setDeepLink,
  getZipCodes,
  getPlans,
  setPageName,
} from "../../../Redux/Actions/webAppActions";
import EditZip from "./EditZip";
import FilterBox from "./FilterBox";
import PlanList from "./PlanList";
import ComparePlan from "./ComparePlan";
import Footer from "../../../Themes/Footer/Sharp/Footer";
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";
class SelectPlan extends Component {
  constructor(props) {
    super(props);
    this.state = {
      compareList: this.props.selectedPlansForCompare,
      planTypeFilter: this.props.planType ?? "",
      premiumFilter: "",
      productFilter: this.props.selectedProduct,
      clicked: false,
      snackBarOpen: false,
      alertMsg: "",
      severity: "",
      vertical: "top",
      horizontal: "center",
      planNotAvailable: false,
    };
  }

  async componentWillMount() {
    let queryString = window.location.search;
    let customerId = "";
    let zipCd = "";
    let countyCd = "";
    let stateCd = "";
    let countyName = "";
    let productID = "";
    let username = "";
    let lang = "";
    let year = "";

    if (queryString.includes("deepLink=true")) {
      let queryStringArray = queryString.split("&");
      if (queryStringArray[1].includes("customerId")) {
        customerId = window.atob(queryStringArray[1].split("=")[1]);
      }

      if (queryStringArray[2].includes("zipCd")) {
        zipCd = window.atob(queryStringArray[2].split("=")[1]);
      }

      if (queryStringArray[3].includes("countyCd")) {
        countyCd = window.atob(queryStringArray[3].split("=")[1]);
      }

      if (queryStringArray[4].includes("stateCd")) {
        stateCd = window.atob(queryStringArray[4].split("=")[1]);
      }
      if (queryStringArray[5].includes("countyName")) {
        countyName = window.atob(queryStringArray[5].split("=")[1]);
      }
      if (queryStringArray[6].includes("productId")) {
        productID = window.atob(queryStringArray[6].split("=")[1]);
      }
      if (queryStringArray[7].includes("email")) {
        username = window.atob(queryStringArray[7].split("=")[1]);
      }
      if (queryStringArray[13].includes("year")) {
        year = window.atob(queryStringArray[13].split("=")[1]);
      }
      if (queryStringArray[14].includes("lang")) {
        lang = window.atob(queryStringArray[14].split("=")[1]);
      }
      this.props.setStateParams("language", lang);
      this.props.setStateParams("county", countyName);
      window.sessionStorage.setItem("zipcode",zipCd)
      window.sessionStorage.setItem("year",year)
      window.sessionStorage.setItem("guestLogin",true)
      window.sessionStorage.setItem("countySelect",countyName)
      this.props.yearSelection(year);
      await this.props.setDeepLink({
        deeplink: true,
        countyName: countyName,
        zipcode: zipCd,
        productId: productID,
        stateCd: stateCd,
        email: username,
      });
      let guestpayload = {
        customerId: customerId,
        username: this.props.dpemail,
      };
      this.props.setLoginStateParams("deeplinkflag", true);
      const guestLoginDetails = await this.props.guestLogin(guestpayload);
      await this.props.setTokenTORedux(guestLoginDetails.data.token);
      await this.props.getZipCodes(zipCd);
      await this.props.setStateParams("zip", zipCd);
      window.sessionStorage.setItem("token",guestLoginDetails.data.token)
      await this.props.getPlansEmail(
        zipCd,
        countyCd,
        customerId,
        stateCd,
        year,
        "Bearer " + guestLoginDetails.data.token
      );
      history.push("/e-Enroll/select-plan");
    }
    if (this.props.zipCode === "" || this.props.zipCode === undefined) {
      let zipcd = window.sessionStorage.getItem("zipcode");
      if (zipcd) {
        await this.props.setStateParams("zip", zipcd);
        if (
          this.props.emailAddress === "" ||
          this.props.firstName === "" ||
          this.props.email === "" ||
          this.props.agentEmailId === undefined
        ) {
          if (window.sessionStorage.getItem("agentLogin") === "true") {
            this.props.setLoginStateParams(
              "agentEmailId",
              window.sessionStorage.getItem("email")
            );
            this.props.setLoginStateParams(
              "firstName",
              window.sessionStorage.getItem("firstName")
            );
            await this.props.setLoginStateParams(
              "agentFullName",
              window.sessionStorage.getItem("agentFullName")
            );
            this.props.setLoginStateParams("agentLoggedIn", true);
            this.props.setLoginStateParams(
              "agentId",
              window.sessionStorage.getItem("agentId")
            );
            this.props.setLoginStateParams(
              "agencyIDSelected",
              window.sessionStorage.getItem("agencyId")
            );
            this.props.setStateParams("guestLoggedIn", false);
            this.props.setLoginStateParams("guestLogin", false);
            this.props.setStateParams(
              "isAgentRole",
              window.sessionStorage.getItem("isAgentRole") === "true"
                ? true
                : false
            );
            this.props.setStateParams(
              "isSuperUser",
              window.sessionStorage.getItem("isSuperUser") === "true"
                ? true
                : false
            );
          }
          if (
            window.sessionStorage.getItem("guestLogin") === "false" &&
            window.sessionStorage.getItem("agentLogin") === "false"
          ) {
            this.props.setLoginStateParams(
              "emailAddress",
              window.sessionStorage.getItem("email")
            );
            this.props.setLoginStateParams(
              "firstName",
              window.sessionStorage.getItem("firstName")
            );
            this.props.setStateParams("guestLoggedIn", false);
            this.props.setLoginStateParams("guestLogin", false);
            this.props.setLoginStateParams(
              "authenticatedData",
              JSON.parse(window.sessionStorage.getItem("authenticatedData"))
            );
          }

          this.props.setLoginStateParams(
            "userId",
            // window.sessionStorage.getItem("userId") ?? 
            // "Guest"
            this.props.userId

          );
        }
        await this.props.setStateParams(
          "year",
          window.sessionStorage.getItem("year")
        );
        this.props.setLoginStateParams(
          "guestLogin",
          window.sessionStorage.getItem("guestLogin") == "true" ? true : false
        );
        this.props.setLoginStateParams(
          "agentLoggedIn",
          window.sessionStorage.getItem("agentLoggedIn") == "true"
            ? true
            : false
        );
        this.props.setLoginStateParams(
          "beneficiaryLogin",
          window.sessionStorage.getItem("beneficiaryLogin") == "true"
            ? true
            : false
        );

        if (this.props.token === "" || this.props.token === undefined) {
          await this.props.setTokenTORedux(
            window.sessionStorage.getItem("token")
          );
        }
        await this.props.getZipCodes(zipcd);

        if (zipcd.length === 5) {
          let call = true;

          if (this.props.ZipCodes && this.props.ZipCodes.length === 1) {
            await this.props.setStateParams(
              "county",
              this.props.ZipCodes[0].countyName
            );
          } else if (
            this.props.ZipCodes &&
            this.props.ZipCodes.length > 1
            // &&
            // this.state.countySelect !== ""
          ) {
            await this.props.setStateParams(
              "county",
              window.sessionStorage.getItem("countySelect")
            );
          }

          if (call === true) {
            const params = this.props.ZipCodes.filter(
              (zipcode1) =>
                zipcode1.countyName.search(
                  window.sessionStorage.getItem("countySelect")
                ) != -1
            );

            let body = { customerId: this.props?.customerId };
            await this.props.getPlans(
              zipcd,
              params[0]?.countyCode,
              body.customerId,
              params[0]?.stateCode,
              this.props?.year
            );

            if (this.props.cardDetails && this.props.cardDetails.length > 0) {
              let payload = { planYear: this.props.year };
              this.props.yearSelection(payload);
              await this.props.setStateParams("preEnrollInfo", {});
              this.setState({
                planNotAvailable: false,
              });
              history.push("/e-Enroll/select-plan");
            } else {
              this.setState({
                planNotAvailable: true,
                //errorMsg: response.message,
              });
            }
          }
        }
        // else {
        //   this.setState({
        //     planNotAvailable: true,
        //     errorMsg: "Please Select a ZipCode!",
        //   });
        // }
      }
    }
  }
  componentDidMount() {
    this.props.setPageName("select-plan");
  }
  setSnackbar = (snackBarOpen, alertMsg, severity) => {
    this.setState({
      ...this.state,
      snackBarOpen: snackBarOpen,
      alertMsg: alertMsg,
      severity: severity,
    });
  };

  handleCompareList = async (list) => {
    let productIsSupp = false;
    list.map((productId) => {
      productIsSupp = this.props.cardDetails.find(
        (det) =>
          det.productId === productId && det.productName.includes("Supplement")
      );
    });
    if (productIsSupp) {
      await this.props.setStateParams("detailsPlanType", "supplement");
    }
    await this.props.setStateParams(
      "isCompare",
      list.length > 0 ? true : false
    );
    await this.props.setStateParams("selectedPlansForCompare", list);
    await this.setState({
      compareList: list,
    });
  };
  handleReset = async () => {
    await this.setState({
      planTypeFilter: "",
      premiumFilter: "",
      productFilter: "",
    });
  };
  handleReset2 = async () => {
    await this.setState({
      planTypeFilter: "",
      premiumFilter: "",
    });
  };

  handleFilter = async (filterType, filterData) => {
    await this.setState({
      [filterType]: filterData,
    });
  };

  render() {
    const {
      compareList,
      planTypeFilter,
      premiumFilter,
      productFilter,
      snackBarOpen,
      alertMsg,
      severity,
      vertical,
      horizontal,
    } = this.state;
    // console.log(
    //   "checkprop=>",
    //   this.props.isCompare,
    //   this.props.selectedPlansForCompare
    // );

    return (
      <>
        <main className="main-content-area bg-white" id="main-content">
          <Snackbar
            open={snackBarOpen}
            autoHideDuration={6000}
            onClose={() =>
              this.setState({
                ...this.state,
                snackBarOpen: false,
              })
            }
            anchorOrigin={{ vertical, horizontal }}
            key={vertical + horizontal}
          >
            <Alert
              onClose={() =>
                this.setState({
                  ...this.state,
                  snackBarOpen: false,
                })
              }
              severity={severity}
            >
              {alertMsg}
            </Alert>
          </Snackbar>
          <div className="container-fluid container-xxl" id="page-wrap">
            <div className="panel-box">
              <EditZip  setSnackbar={this.setSnackbar}/>
              <FilterBox
                handleFilter={this.handleFilter}
                handleReset={this.handleReset}
                handleReset2={this.handleReset2}
                clicked={this.state.clicked}
                removeCompareList={() => {
                  this.setState({ ...this.state, compareList: [] });
                }}
              />
              <PlanList
                handleCompareList={this.handleCompareList}
                planTypeFilter={planTypeFilter}
                premiumFilter={premiumFilter}
                productFilter={productFilter}
                handleHeaderWidth={() => {
                  this.setState({
                    ...this.state,
                    clicked: !this.state.clicked,
                  });
                }}
                compareList={compareList}
                disablePlan={compareList.length > 2 ? true : false}
                planNotAvailable={this.state.planNotAvailable}
              />
            </div>
          </div>
        </main>
        <Footer />
        {this.props.isCompare &&
        this.props.selectedPlansForCompare.length > 0 ? (
          <ComparePlan
            key={this.props.selectedPlansForCompare.length}
            compareList={this.props.selectedPlansForCompare}
            handleCompareList={this.handleCompareList}
            setSnackbar={this.setSnackbar}
          />
        ) : (
          ""
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    customerId: state.login.customerId,
    lang: state.webApp.language,
    agentLogin: state.login.agentLoggedIn,
    email: state.login.agentEmailId,
    cardDetails: state.webApp.planCardData,
    token: state.login.token,
    zipCode: state.webApp.zip,
    ZipCodes: state.webApp.zipCodes,
    firstName: state.login.firstName,
    emailAddress: state.login.emailAddress,
    dpemail: state.login.dpemail,
    isAgentRole: state.webApp.isAgentRole,
    isSuperUser: state.webApp.isSuperUser,
    agentEmailId: state.login.agentEmailId,
    // guestLogin: state.login.guestLogin,
    beneficiaryLogin: state.login.beneficiaryLogin,
    selectedProduct: state.webApp.selectedProduct,
    selectedPlansForCompare: state.webApp.selectedPlansForCompare,
    planType: state.webApp.planType,
    isCompare: state.webApp.isCompare,
    dataSet: state.webApp,
    year: state.webApp.year?.planYear
      ? state.webApp.year?.planYear
      : state.webApp.year,
      userId:state.login.userId
  };
};
const mapDispatchToProps = {
  yearSelection,
  removeplan,
  agentCategoryDashboard,
  setStateParams,
  setLoginStateParams,
  getPlansEmail,
  guestLogin,
  setTokenTORedux,
  setDeepLink,
  getZipCodes,
  getPlans,
  setPageName,
};

export default connect(mapStateToProps, mapDispatchToProps)(SelectPlan);
